// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var Theme__Color__Vars = require("../../common/Theme/Theme__Color__Vars.bs.js");

function SearchField(props) {
  var onChange = props.onChange;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("input", {
                      className: "block flex-grow bg-white text-zinc-700 placeholder:text-zinc-500 placeholder:text-lg px-[15px] py-2.5 text-lg leading-5 border-0 outline-none focus:outline-none appearance-none rounded-none transition-colors duration-150 m-0",
                      placeholder: props.placeholder,
                      type: "search",
                      value: props.value,
                      onChange: (function (e) {
                          Core__Option.forEach(onChange, (function (cb) {
                                  cb(e);
                                }));
                        })
                    }),
                JsxRuntime.jsx("button", {
                      children: JsxRuntime.jsx(Icon__Jsx3.make, {
                            icon: "Search",
                            size: 20,
                            color: Theme__Color__Vars.silver
                          }),
                      className: "w-[42px] h-[42px] border-0 flex justify-center items-center shrink-0",
                      type: "button"
                    })
              ],
              className: "max-w-[500px] h-11 border border-zinc-300 hover:border-zinc-400 focus-within:border-tan-focused-border flex"
            });
}

var Icon;

var make = SearchField;

exports.Icon = Icon;
exports.make = make;
/* Icon__Jsx3 Not a pure module */
